define(
    'modules/orders',[
        'jquery',

        'utils/toast',

        'connections/order-connection',

        'server-settings'
    ],

    function ($, Toast, OrderConnection, serverSettings) {
        /**
         * @class Orders
         * @constructor
         */
        function Orders () {}
        /**
         * @property orders
         * @type {Array}
         */
        Orders.prototype.orders = [];

        /**
         * @property lastId
         * @type {string|number}
         */
        Orders.prototype.lastId = 0;

        /**
         * @property size
         * @type {number}
         * @default 5
         */
        Orders.prototype.size = 5;

        Orders.prototype.lastFetch = [];

        /**
         * Used when searching for a specific order
         *
         * @property itemCode
         * @type {string|null}
         */
        Orders.prototype.searchText = null;

        /**
         * @method setNumberToLoad
         * @param n
         */
        Orders.prototype.setNumberToLoad = function (n) {
            this.size = n;
        };

        /**
         * @method loadAdditional
         */
        Orders.prototype.loadAdditional = function () {
            var self = this;

            return OrderConnection.getOrderHeaders(this.searchText, this.lastId, this.size)
                .then(
                    function (orders) {
                        self.lastFetch.splice(0, self.lastFetch.length);

                        $.each(orders, function (i, order) {
                            self.orders.push(order);
                            self.lastFetch.push(order);
                        });

                        self.lastId = orders.length ? orders[orders.length - 1].id : 0;
                        
                    },
                    function() {
                        Toast.queueError('Failed to load orders.');
                    });
        };

        /**
         * @method reload
         */
        Orders.prototype.reload = function () {
            this.orders.splice(0, this.orders.length);
            this.lastFetch.splice(0, this.lastFetch.length);
            this.lastId = 0;
            return this.loadAdditional();
        };

        Orders.prototype.search = function (q) {
            this.searchText = q;
            return this.reload();
        };
        
        /**
         * @method viewDetails
         */
        Orders.prototype.viewDetails = function (url) {
            window.document.location = url;
        };

        /**
         * @method viewTracking
         */
        Orders.prototype.getTracking = function ($el, id) {
            if ($el.data('loaded')) return;

            var $loader = $('<span class="loader"></span>');
            $el.after($loader);           
            OrderConnection.getTrackingLinks(id)
                .then(function(trackingLinks) {
                    if (!trackingLinks.length) {
                        Toast.queue("No tracking links available for this order.");                        
                        return;
                    }                    
                    $el.data('loaded', true);

                    var getClickHandlerForLink = function(link) {
                        return function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            window.open(link, '_blank');
                        };
                    };

                    for (var i = trackingLinks.length - 1; i >= 0; i--) {
                        var link = trackingLinks[i].trackingUrl;
                        if (!link) return;

                        var $link = $('<a href="' + link + '">' + (i + 1) + '</a>');
                        $link.on('click', getClickHandlerForLink(link)); 
                        
                        $el.after($link);
                    }

                    $el.addClass('loaded');
                })
                .fail(function() {
                    $el.data('loaded', false);
                })
                .always(function() {
                    $loader.remove();
                });
        };

        return Orders;
    }
);
